import type { ErrorLike } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { graphql, readFragment } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

const FeedCollectionForDropdown = graphql(/* GraphQL */ `
  fragment FeedCollectionForDropdown on FeedCollection {
    id
    name
    feeds {
      id
    }
  }
`)

const GetFeedCollectionsForDropdown = graphql(
  /* GraphQL */ `
    query GetFeedCollectionsForDropdown($organizationId: OrganizationId!) {
      feedCollections(first: 100, input: { organizationId: $organizationId }) {
        edges {
          node {
            ...FeedCollectionForDropdown
          }
        }
      }
    }
  `,
  [FeedCollectionForDropdown],
)

type FeedCollectionForDropdownData = ResultOf<typeof FeedCollectionForDropdown>

type UseFeedCollectionsForDropdownResult = {
  loading: boolean
  error?: ErrorLike
  collections: FeedCollectionForDropdownData[]
}

export const useFeedCollectionsForDropdown = (options: {
  organizationId: string | undefined | null
}): UseFeedCollectionsForDropdownResult => {
  const { organizationId } = options
  const { data, loading, error } = useQuery(GetFeedCollectionsForDropdown, {
    variables: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      organizationId: organizationId ?? '',
    },
    skip: !organizationId,
    fetchPolicy: 'cache-and-network',
  })

  const collections =
    data?.feedCollections.edges.map((edge) =>
      readFragment(FeedCollectionForDropdown, edge.node),
    ) ?? []

  return {
    loading,
    error,
    collections,
  }
}
